import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var attendanceStatusListRes;
export const attendanceStatusListTodo = createAsyncThunk('attendanceStatusList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/attendence_status',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "ibusiness_area_id": user_id.ibusiness_area_id,
                "vfin_year_name": data.year,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return attendanceStatusListRes = res.data
    } catch (error) {
        return attendanceStatusListRes = error.response.data
    }
})


const attendanceStatusListSlice = createSlice({
    name: 'attendanceStatusList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(attendanceStatusListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('attendanceStatusList', state.data)
            }
        });
        builder.addCase(attendanceStatusListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default attendanceStatusListSlice.reducer; 